/**
 * サイズ別の行UI
 *
 * - カート追加: /cart/add.js へ直接POST（行ごとにロック）。ページに留まる
 * - お気に入り: Prime Review の Ajax API（window.PrimeReviewFavorite）
 * - 再入荷通知: Amp Back in Stock（class="BIS_trigger"）へ商品JSONを注入するだけ
 * - 名入れ: 名入れ商品では印字内容を properties に載せて送る（collectEngraving）
 *
 * 【カート追加を書き換えるときの注意】
 * 名入れ商品はこのUIが唯一の送信経路。購入フォームを出さないため、properties を
 * 落とすと入力欄は出るのに印字内容が付かないまま注文が通る。
 * 関連: snippets/product-name-engraving.liquid / snippets/product-template.liquid
 *
 * theme.AjaxProduct は使わない。
 * cart_type が page のため success 時に無条件で /cart へ遷移してしまうのと、
 * 読み込み中フラグがモジュール共有で行ごとのロックにできないため。
 */
(function() {
  'use strict';

  if (window.__sizeRowsInit) return;
  window.__sizeRowsInit = true;

  var MSG_DURATION = 5000;
  var ADDED_DURATION = 2000;

  function init(scope) {
    var containers = scope.querySelectorAll('[data-size-rows]');

    for (var i = 0; i < containers.length; i++) {
      setupContainer(containers[i]);
    }
  }

  function setupContainer(container) {
    if (container.dataset.sizeRowsBound === 'true') return;
    container.dataset.sizeRowsBound = 'true';

    injectBisProductData(container);
    hideAppBlockNotifyButton();
    setupFavorites(container);

    container.addEventListener('click', function(evt) {
      var addBtn = evt.target.closest('[data-size-row-add]');
      if (addBtn) {
        evt.preventDefault();
        addToCart(container, addBtn);
        return;
      }

      var loginLink = evt.target.closest('[data-size-row-login]');
      if (loginLink) {
        // href は残してあるので、JSが無効でもログインへは行ける。
        // ここでは無言で飛ばさず、理由を伝えてから遷移させる。
        evt.preventDefault();
        showLoginPrompt(container, loginLink);
      }
    });
  }

  /* ============================================================
     カート追加
     ============================================================ */

  function addToCart(container, btn) {
    if (btn.dataset.loading === '1') return;

    var row = btn.closest('[data-size-row]');
    var variantId = btn.dataset.variantId;
    var defaultText = btn.textContent.trim();

    // 名入れ商品は印字内容が揃うまでカートに入れない
    var engraving = collectEngraving(container, row);
    if (engraving === false) return;

    btn.dataset.loading = '1';
    btn.disabled = true;
    btn.classList.add('btn--loading');
    clearMessage(row);

    fetch(container.dataset.cartAddUrl + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [buildCartItem(variantId, engraving)] })
    })
      .then(function(response) {
        return response.json().then(function(data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function(result) {
        if (!result.ok) {
          // 在庫不足などは Shopify が日本語の description を返す
          showMessage(row, result.data.description || result.data.message || container.dataset.errorText, true);
          return;
        }

        btn.textContent = container.dataset.addedText;
        btn.classList.add('size-row__btn--added');
        window.setTimeout(function() {
          btn.textContent = defaultText;
          btn.classList.remove('size-row__btn--added');
        }, ADDED_DURATION);

        refreshCart(container);
      })
      .catch(function(err) {
        console.warn('[size-rows] add to cart failed', err);
        showMessage(row, container.dataset.errorText, true);
      })
      .then(function() {
        btn.dataset.loading = '0';
        btn.disabled = false;
        btn.classList.remove('btn--loading');
      });
  }

  /* ============================================================
     名入れ（印字内容）

     名入れフォームは購入フォームの外にある独立ブロック。行UIが有効な商品では
     購入フォームそのものが出力されないため、入力値を運ぶのはこの経路だけになる。
     ============================================================ */

  // 戻り値: false=中止 / null=名入れ商品ではない / オブジェクト=送る properties
  function collectEngraving(container, row) {
    if (container.dataset.requiresEngraving !== 'true') return null;

    var inputs = findEngravingInputs(container);

    // タグは付いているのに入力欄が無い＝ブロック未配置などの設定漏れ。
    // 印字内容の無い注文を通さないためカート追加を止める
    if (!inputs || !inputs.length) {
      showMessage(row, container.dataset.engravingMissingText || container.dataset.errorText, true);
      return false;
    }

    var properties = {};

    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];

      // 検証の規則は入力欄側（required / pattern / maxlength）が持つ。
      // form に属していない入力欄でも制約検証はそのまま働く
      if (!input.checkValidity()) {
        showMessage(row, container.dataset.engravingErrorText || container.dataset.errorText, true);
        if (input.reportValidity) input.reportValidity();
        else input.focus();
        return false;
      }

      var key = getPropertyKey(input);
      var value = input.value.replace(/^ +| +$/g, '');
      // 任意欄が空のときは送らない。空の行がカートに出るのを防ぐ
      if (key && value) properties[key] = value;
    }

    return properties;
  }

  // 名入れフォームは同じ商品セクション内にある
  function findEngravingInputs(container) {
    var scope = container.closest('.product-section') || document;
    var form = scope.querySelector('[data-name-engraving]');
    if (!form) return null;
    return form.querySelectorAll('.name-engraving__input');
  }

  // name="properties[1行目]" からキー名を取り出す。
  // キー名は受注連携と納品書の前提なので、JS側では決め打ちにしない
  function getPropertyKey(input) {
    var matched = /^properties\[(.+)\]$/.exec(input.getAttribute('name') || '');
    return matched ? matched[1] : '';
  }

  function buildCartItem(variantId, engraving) {
    var item = { id: variantId, quantity: 1 };
    if (engraving && Object.keys(engraving).length) {
      item.properties = engraving;
    }
    return item;
  }

  function refreshCart(container) {
    fetch(container.dataset.cartUrl + '.js', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      cache: 'no-store'
    })
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        updateCartBubble(cart.item_count);
        updateCartLink(container, cart.item_count);

        // ノベルティ案内（あと◯円でノベルティ）が既に購読しているイベント
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { cart: cart }
        }));

        // ajaxProduct:added は投げない。
        // recipient-form（ギフトカード用）が event.target から [name="id"] を
        // null チェックなしで読むため、フォームを持たないこのUIから投げると壊れる。
        document.dispatchEvent(new CustomEvent('sizeRows:added', {
          detail: { cart: cart }
        }));
      })
      .catch(function(err) {
        console.warn('[size-rows] cart refresh failed', err);
      });
  }

  function updateCartBubble(count) {
    var bubbles = document.querySelectorAll('.cart-link__bubble');
    for (var i = 0; i < bubbles.length; i++) {
      bubbles[i].classList.toggle('cart-link__bubble--visible', count > 0);
    }

    var nums = document.querySelectorAll('.cart-link__bubble-num');
    for (var j = 0; j < nums.length; j++) {
      nums[j].innerText = count;
    }
  }

  function updateCartLink(container, count) {
    var wrap = container.querySelector('[data-size-rows-cart-link]');
    if (!wrap) return;

    var link = wrap.querySelector('[data-size-rows-cart-link-text]');
    if (link && link.dataset.baseText === undefined) {
      link.dataset.baseText = link.textContent.trim();
    }
    if (link) {
      link.textContent = link.dataset.baseText + '（' + count + '）';
    }
    wrap.hidden = count === 0;
  }

  /* ============================================================
     お気に入り（Prime Review）
     ============================================================ */

  function setupFavorites(container) {
    var buttons = container.querySelectorAll('[data-size-row-fav]');
    if (!buttons.length) return;

    for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener('click', function(evt) {
        evt.preventDefault();
        toggleFavorite(container, evt.currentTarget);
      });
    }
  }

  function getFavoriteApi() {
    var api = window.PrimeReviewFavorite;
    if (!api || typeof api.submitFavorite !== 'function') return null;
    return api;
  }

  function toggleFavorite(container, btn) {
    // Prime Review 未導入・未読み込みでもテーマ側がエラーにならないようにする
    var api = getFavoriteApi();
    if (!api) {
      console.warn('[size-rows] PrimeReviewFavorite is not available');
      return;
    }

    if (btn.disabled) return;
    btn.disabled = true;

    var row = btn.closest('[data-size-row]');
    var isFaved = btn.dataset.faved === 'true';
    var method = isFaved ? api.removeFavorite : api.submitFavorite;

    Promise.resolve(
      method.call(api, container.dataset.productHandle, btn.dataset.variantId, container.dataset.customerId)
    )
      .then(function() {
        var next = !isFaved;
        btn.dataset.faved = String(next);
        btn.classList.toggle('is-active', next);
        btn.setAttribute('aria-pressed', String(next));
      })
      .catch(function(err) {
        console.warn('[size-rows] favorite failed', err);
        showMessage(row, container.dataset.favErrorText, true);
      })
      .then(function() {
        btn.disabled = false;
      });
  }

  function showLoginPrompt(container, link) {
    var row = link.closest('[data-size-row]');
    var msg = row.querySelector('[data-size-row-msg]');
    if (!msg) {
      window.location.href = link.href;
      return;
    }

    msg.innerHTML = '';
    msg.appendChild(document.createTextNode(link.getAttribute('aria-label') + ' '));

    var action = document.createElement('a');
    action.href = link.href;
    action.className = 'size-row__msg-link';
    action.textContent = link.dataset.loginText || 'ログインする';
    msg.appendChild(action);

    msg.classList.add('is-visible');
  }

  /* ============================================================
     再入荷通知（Amp Back in Stock）
     ============================================================ */

  /*
    従来の再入荷通知ボタン（アプリブロック）は行UIに統合されるので隠す。
    削除ではなく非表示にとどめるのは、_BISConfig の供給元がこのブロック側だった場合に
    行UI側の通知まで動かなくなるのを避けるため。
  */
  function hideAppBlockNotifyButton() {
    var appBlock = document.querySelector('[data-bis-app-block]');
    if (!appBlock) return;

    var wrapper = appBlock.closest('.product-block') || appBlock.closest('.shopify-app-block');
    if (wrapper) {
      wrapper.style.display = 'none';
    } else {
      appBlock.style.display = 'none';
    }
  }

  function injectBisProductData(container) {
    var json = container.querySelector('[data-bis-product-json]');
    if (!json) return;

    var triggers = container.querySelectorAll('.BIS_trigger');
    for (var i = 0; i < triggers.length; i++) {
      // JSON.parse せずテキストのまま渡す。AMP 側が parse するため二度手間を避ける
      triggers[i].setAttribute('data-product-data', json.textContent);
    }
  }

  /* ============================================================
     メッセージ表示
     ============================================================ */

  function showMessage(row, text, isError) {
    if (!row) return;
    var msg = row.querySelector('[data-size-row-msg]');
    if (!msg) return;

    msg.textContent = text;
    msg.classList.add('is-visible');
    msg.classList.toggle('size-row__msg--error', !!isError);

    window.clearTimeout(msg.dataset.timer);
    msg.dataset.timer = window.setTimeout(function() {
      clearMessage(row);
    }, MSG_DURATION);
  }

  function clearMessage(row) {
    if (!row) return;
    var msg = row.querySelector('[data-size-row-msg]');
    if (!msg) return;

    msg.textContent = '';
    msg.classList.remove('is-visible', 'size-row__msg--error');
  }

  /* ============================================================
     起動
     ============================================================ */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { init(document); });
  } else {
    init(document);
  }

  // テーマエディタでのセクション再描画に対応する
  document.addEventListener('shopify:section:load', function(evt) {
    init(evt.target);
  });
})();
